export const linkProducaoPaginas = "https://oikos.ecoss.is/oikos-client/";
export const linkProducaoVM = "https://oikos.ecoss.is/oikos/";
export const linkOikosLabPaginas = "https://oikoslab.ecoss.is/";
export const linkOikosLabVM = "https://oikoslab.ecoss.is/oikos/";

/** Base de arquivos = host da API (lab ou prod conforme .env). */
export const getOikosFileUrl = (path) => {
  if (!path) return ''
  if (/^https?:\/\//i.test(path)) return path
  const api = process.env.REACT_APP_OIKOS_API_URL || 'https://oikos.ecoss.is/oikos/_oikos_api.php'
  const base = api.replace(/\/_oikos_api\.php.*$/i, '/').replace(/\/?$/, '/')
  return `${base}${String(path).replace(/^\//, '')}`
}
